import React from 'react';
import ReactSelect, { SingleValue } from 'react-select';
import { QuestionnaireOption, QuestionnaireSelectorProps } from './interface';
import { useSearchQuestionnaires } from './useSearchQuestionnaires';
import useDebouncedSearchTerm from '../../hooks/useDebouncedSearchTerm';
import { isString } from './utils';
import useQuestionnaireOptions from './useQuestionnaireOptions';

function QuestionnaireSelector(props: QuestionnaireSelectorProps) {
  const { value: questionnaireId, onChange, disabled } = props;

  const { setValue, immediateValue, debouncedValue } = useDebouncedSearchTerm();
  const { questionnaires } = useSearchQuestionnaires(debouncedValue);

  const { options, selectedOption } = useQuestionnaireOptions({
    questionnaires,
    selectedQuestionnaireId: questionnaireId
  });

  const handleSelectChange = (option: SingleValue<QuestionnaireOption>) => {
    if (isString(option?.value)) {
      onChange(option.value);
    }

    if (option === null) {
      onChange(null);
    }
  };

  return (
    <ReactSelect
      isClearable
      isDisabled={disabled}
      placeholder="Enter questionnaire name"
      options={options}
      value={selectedOption}
      inputValue={immediateValue}
      onInputChange={setValue}
      onChange={handleSelectChange}
    />
  );
}

export default QuestionnaireSelector;
